import { NotifiableError } from '@bugsnag/js'
import { trackSegmentEvent } from '@/services/api/segment'
import { report } from '@/utils'
import { TrackEvents } from './types'

const ServerSegmentHandler = {
  track: async <
    T extends keyof TrackEvents,
    R extends TrackEvents[T] & {
      userId?: string
      anonymousId: string
    }
  >(
    name: T,
    properties: R
  ) => {
    if (!properties.anonymousId) {
      report.error('Anonymous ID must be passed in properties on server')
      return
    }

    const { userId, anonymousId } = properties

    try {
      await trackSegmentEvent(name, {
        ...properties,
        anonymous_id: anonymousId,
        user_id: userId,
      })
    } catch (err) {
      report.error(err as NotifiableError)
    }
  },
}

export default ServerSegmentHandler
